import {
  Component,
  ElementRef,
  ViewChild,
  input,
  output,
  signal,
  AfterViewInit,
  inject,
} from '@angular/core';
import { BrowserMultiFormatReader } from '@zxing/library';
import { I18nService } from '../../services/i18n.service';
import { UiService } from '../../services/ui.service';
import { BrowserMultiFormatReaderInverse } from '../../utilities/browserMultiFormatReaderInverse';
import { NavButtonComponent } from '../nav-button/nav-button';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'app-image-scanner',
  imports: [NavButtonComponent, NzIconModule],
  templateUrl: './image-scanner.html',
  styleUrls: ['./image-scanner.scss'],
})
export class ImageScannerComponent implements AfterViewInit {
  @ViewChild('img') img: ElementRef<HTMLImageElement> | undefined;

  public image = input.required<string>();
  public matrixCode = input<boolean>(false);

  public codeScanned = output<string>();
  public scanError = output<void>();
  public scanCanceled = output<void>();

  public error = signal<boolean>(false);
  public success = signal<boolean>(false);

  public i18n = inject(I18nService);
  private ui = inject(UiService);

  get isMobile(): boolean {
    return this.ui.IsMobile();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (!this.img) {
        this.error.set(true);
        this.emitResult(this.scanError, undefined);
        return;
      }

      const isMatrixCode = this.matrixCode();

      const codeReader = isMatrixCode
        ? new BrowserMultiFormatReaderInverse()
        : new BrowserMultiFormatReader();

      codeReader
        .decodeFromImageElement(this.img.nativeElement)
        .then((result: { getText: () => string }) => {
          this.success.set(true);
          this.emitResult(this.codeScanned, result.getText());
        })
        .catch(() => {
          this.error.set(true);
          this.emitResult(this.scanError, undefined);
        });
    }, 300);
  }

  emitResult<T>(event: { emit: (value: T) => void }, params: T) {
    setTimeout(() => {
      event.emit(params);
    }, 500);
  }

  onCancelScan(): void {
    this.scanCanceled.emit();
  }
}
